import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFilterByTypeModal = createSelector(
  [(store: RootState) => store.documentsList.showFilterByTypeModal],
  (type) => type
);
